import { useProducts } from '@activebrands/core-web/contexts/ProductsContext';
import SortOptions from 'components/product-listing/SortOptions';

const CategorySortOptions = () => {
    const { sortBy, sortOrder, applySort } = useProducts();

    return (
        <SortOptions applySort={applySort} overlayId="category-sort-options" sortBy={sortBy} sortOrder={sortOrder} />
    );
};

export default CategorySortOptions;
